<template>
    <span class="mobile-search-functionality-logic-component">
        <a href="#" class="select2-button select2-button-arrow small-margin" @click.prevent="closeSelect"></a>
        <div class="searchRadius">
            <select class="form-control rounded-0-left" id="radius" @change="setSearchRadius" v-if="!hideDistanceOnMobile">
                <option v-for="(description, radius) in locationRadiuses" :value="radius"
                        :selected="searchRadius == radius">
                    {{ description }}
                </option>
            </select>
        </div>
    </span>
</template>

<script>
const data = () => {
    return {
        store: $store,
        locationRadiuses: constants.search_radius,
    }
};

function setSearchRadius(event) {
    const radius = _.get(event, 'target.value', '20km');
    this.store.commit('setSearchRadius', radius);
    this.store.commit('refreshSearch');
    this.closeSelect();
}

function closeSelect() {
    this.searchElement.select2("close");
}

export default {
    data,
    computed: {
        ...mapState(['searchRadius']),
    },
    props: ['searchElement', 'hideDistanceOnMobile'],
    methods: {
        setSearchRadius,
        closeSelect,
    }
}
</script>
